import Search from 'antd/lib/input/Search'
import { startTransition, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { createObjectTree } from './helpers/object-tree.helper'
import styles from './object-tree.module.scss'
import { PureTree } from '../../../../common/ui/pure-tree/pure-tree'
import { ObjectItem } from '../../../../entities/objects/types/object.types'

type ObjectTreeProps = {
  objects: ObjectItem[]
  checked?: Set<number>
  onCheck: (objectIds: number[]) => void
}

export const ObjectTree = ({ objects, checked, onCheck }: ObjectTreeProps) => {
  const { t } = useTranslation()

  const [search, setSearch] = useState<string[] | null>()

  const { objectsTree, checkedKeys: checkedObjects } = useMemo(() => {
    let readyObjects = [...objects]
    if (search) {
      readyObjects = [...objects].filter((object) =>
        search.find((part) => String(object.id).includes(part) || object.name.toLowerCase().includes(part)),
      )
    }

    return createObjectTree(readyObjects, t, checked)
  }, [objects, search])

  const handleCheck = (checkedIds: number[]) => {
    startTransition(() => {
      onCheck(checkedIds.filter((id) => !isNaN(id)))
    })
  }

  const handleSearch = (searchString: string) => {
    if (searchString) {
      const searchParts = searchString.split(',').map((part) => part.toLowerCase().trim())
      setSearch(searchParts)
    } else {
      setSearch(null)
    }
  }

  return (
    <div className={styles.objectTreeWrap}>
      <div>
        <Search
          className={styles.objectTreeSearch}
          onChange={(event) => handleSearch(event.target.value)}
          placeholder={t('workspace.searchObjects')}
        />
      </div>
      <div className="mt-3">
        <PureTree
          initialState={checkedObjects ?? []}
          onCheck={handleCheck}
          treeData={objectsTree}
        />
      </div>
    </div>
  )
}
